var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar",staticStyle:{"border-bottom":"2px solid","margin-bottom":"5px"},attrs:{"role":"navigation","aria-label":"main navigation"}},[_c('div',{staticClass:"navbar-menu",attrs:{"id":"navbarBasicExample"}},[_c('div',{staticClass:"navbar-end",staticStyle:{"margin-right":"18px"}})])])
}]

export { render, staticRenderFns }